import { createClientAuth } from '@whoop/auth-client';

/**
 * Gets the user ID from auth client and sets it in amplitude
 *
 * This function will return undefined if the user is not authenticated
 * or if there's an error retrieving the user
 */
export async function getUserId(): Promise<number | undefined> {
  try {
    const auth = createClientAuth({
      env: process.env.NEXT_PUBLIC_ENV === 'prod' ? 'prod' : 'dev',
      segmentKey: process.env.NEXT_PUBLIC_SEGMENT_API_KEY ?? '',
    });
    const user = await auth.getUser();
    return user?.id;
  } catch (error) {
    return undefined;
  }
}
